<script>
  import { useForm } from '@inertiajs/svelte'
  import FlashMessage from '../../components/flash_message.svelte'
  import LegacyCmsBanner from '../../components/legacy_cms_banner.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  let { invitation_token = '', minimum_password_length = 8, email = '', name = '' } = $props()

  const form = useForm({
    admin_site_admin: {
      invitation_token,
      name: name || '',
      password: '',
      password_confirmation: ''
    }
  }).withPrecognition('patch', '/sign-up')
  // Validation is the server's: live Precognition requests to the real action, and on submit.
  liveValidate(form, 'admin_site_admin')

  function submit(e) {
    e.preventDefault()
    $form.patch('/sign-up')
  }
</script>

<LegacyCmsBanner />
<div class="min-h-screen bg-base-200 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
  <FlashMessage />
  <div class="card bg-base-100 shadow-md p-8 w-full max-w-md space-y-8">
    <h2 class="text-lg font-bold text-center">Set up your account</h2>
    <p class="text-center text-sm text-base-content/60">{email}</p>

    <form novalidate onsubmit={submit} class="space-y-4">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Name</legend>
        <input
          type="text"
          bind:value={$form.admin_site_admin.name}
          class="input w-full"
          class:input-error={$form.errors['admin_site_admin.name']}
        />
        {#if $form.errors['admin_site_admin.name']}
          <div class="text-error text-sm mt-1">{$form.errors['admin_site_admin.name']}</div>
        {/if}
      </fieldset>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">Password</legend>
        <input
          type="password"
          bind:value={$form.admin_site_admin.password}
          class="input w-full"
          class:input-error={$form.errors['admin_site_admin.password']}
          autocomplete="new-password"
        />
        {#if $form.errors['admin_site_admin.password']}
          <div class="text-error text-sm mt-1">{$form.errors['admin_site_admin.password']}</div>
        {/if}
      </fieldset>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">Confirm password</legend>
        <input
          type="password"
          bind:value={$form.admin_site_admin.password_confirmation}
          class="input w-full"
          class:input-error={$form.errors['admin_site_admin.password_confirmation']}
          autocomplete="new-password"
        />
        {#if $form.errors['admin_site_admin.password_confirmation']}
          <div class="text-error text-sm mt-1">{$form.errors['admin_site_admin.password_confirmation']}</div>
        {/if}
      </fieldset>

      <Button type="submit" variant="primary" block loading={$form.processing}>Complete sign up</Button>
    </form>
  </div>
</div>
